"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderIdSchema = exports.ORDER_DOCUMENT_SECTION = exports.ORDER_DOCUMENT_TYPE_LABELS = exports.orderDocumentTypeSchema = exports.ORDER_DOCUMENT_TYPES = void 0;
exports.orderDocumentCategory = orderDocumentCategory;
exports.isOrderDocumentType = isOrderDocumentType;
const zod_1 = require("zod");
exports.ORDER_DOCUMENT_TYPES = ['sales_order', 'purchase_order'];
exports.orderDocumentTypeSchema = zod_1.z.enum(exports.ORDER_DOCUMENT_TYPES);
exports.ORDER_DOCUMENT_TYPE_LABELS = {
    sales_order: 'Sales Order',
    purchase_order: 'Purchase Order',
};
// `document.section` is CHECK-constrained to the document host sections.
// Order PO/SO are deal-execution documents rather than BL deal-side shipping
// papers, so both land in the Internal section.
exports.ORDER_DOCUMENT_SECTION = 'internal';
// `document_template.category` stores the produced document_type (the Flow 7
// convention). For order documents `document.category` mirrors it — there is no
// coarser BL-style bucket for the two order document types.
function orderDocumentCategory(documentType) {
    return documentType;
}
function isOrderDocumentType(value) {
    return exports.ORDER_DOCUMENT_TYPES.includes(value);
}
exports.orderIdSchema = zod_1.z
    .string()
    .regex(/^\d+$/, 'owner_entity_id must be a numeric order id');
//# sourceMappingURL=order-document-types.js.map